import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import './CosaDicono.css'

function CosaDicono() {
  return (
    <div>
  <Container fluid className="home-section" id="cosadicono">
      <Container className="CosaDicono-content"> 
        <Row md={7} className="CosaDicono-header">
          <h1 style={{ paddingTop: 40}}>
           COSA DICONO DI NOI
          </h1>
        </Row>
      </Container>
    </Container>
  </div>
  );
}

export default CosaDicono;
